import { Heading } from "@chakra-ui/react"
import CustomTabs from "@Modules/core/components/customTab/CustomTabs";
import UpdateOpposingCardsFormHandler from "../../containers/formHandler/cardOperations/opposition/UpdateOpposingCardsFormHandler"
import ReleaseCardFromOppositionFormHandler from "../../containers/formHandler/cardOperations/opposition/ReleaseCardFromOppositionFormHandler";
import CardOppositionHistoryHandler from "../../containers/mixedHandlers/cardOperations/opposition/CardOppositionHistoryTableHandler";

const tabHeaders = [
  'Mise à jour des cartes opposées',
  'Main-Levée d\'une carte en opposition',
  'Historique des oppositions carte.',
];

const tabContents = [
  <UpdateOpposingCardsFormHandler />,
  <ReleaseCardFromOppositionFormHandler />,
  <CardOppositionHistoryHandler />
];

const OppositionPage = () => {
  return (
    <>
      <Heading size="md" mb={"2rem"}>Opposition &gt; Carte </Heading>
      <CustomTabs tabHeaders={tabHeaders} tabContents={tabContents} isLazy={false} />
    </>
  )
}

export default OppositionPage